export default __webpack_public_path__ + "static/media/mike.da320cd2.jpg";